// @core/api/endpoints/authn/list_oauth2_connections.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListOAuth2ConnectionsResponse,
} from '../../../types/authn';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/authn';

/**
 * List OAuth2 connections for user
 * Returns all external OAuth2 provider accounts linked to the current user. Shows connection status and provider information for each linked account.
 */
export async function ListOAuth2Connections(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListOAuth2ConnectionsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/external/connections`;
  const requestOptions = options;
  return client.get<ListOAuth2ConnectionsResponse>(requestPath, { ...requestOptions, params });
}
